import React, { Component } from "react";
import styled from "styled-components";
import { withPage } from "../../Page";
import { StaticFluidImage } from "../../Components/StaticImage/HeCafe";
import IntroSection from "../../Components/IntroSection";
import PartSection from "../../Components/PartSection";

class ServiceTermsPage extends Component {
  render() {
    return (
      <Wrapper>
        <div className="banner">
          <StaticFluidImage
            path="banner05.jpg"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 2
            }}
          />
          <h3>- Terms Of Service -</h3>
        </div>
        <div className="container">
          <Content>
            {`歡迎您成為好咖嚴選平台網站的會員，好咖嚴選平台網站的會員服務（以下簡稱本服務）係由「忻旅科技股份有限公司」（以下稱本公司）所建置提供，所有使用會員服務的使用者（以下稱會員），都應該詳細閱讀下列會員服務條款（以下簡稱本服務條款），本服務條款訂立目的在於保護會員服務的提供者以及所有使用者的利益，並構成會員服務提供者與使用者之間的契約。\n\n當您完成註冊手續、或開始使用本服務時，即視為已閱讀、瞭解並完全同意本使用條款的所有約定，如您不同意本服務條款的內容，或您所屬的國家或地域排除本服務條款內容之全部或部分時，您應立即停止使用本服務。如您為未滿十八歲，則您必須在加入會員前，將本服務條款及其後之修改變更請您的父母或監護人閱讀，並得到其同意，才可以註冊及使用本服務。當您使用本服務時，則視為您的父母或監護人已經閱讀、瞭解並同意本服務條款之內容及其後之修改變更。\n\n一、本網站會員註冊\n當您欲註冊成為「本網站會員」時，本網站會請您提供相關會員個人註冊資訊，所需要之資訊與蒐集目的如下：\n1.電子信箱：作為會員帳號與接收會員相關訊息。\n2.密碼：依帳號登入網站時所必須之確認資訊。\n3.姓名：用以辨識個人。\n4.身分證字號：作為會員帳號與辨識個人，亦可作為會員帳號使用。\n5.出生日期：用以進行會員資料分析與行銷活動。\n6.性別：用以辨識與描述個人。\n7.聯絡住址：用以寄送活動相關贈品。\n8.室內電話及行動電話：用以聯繫、確認與回覆會員所參與之行銷活動與詢問。\n9.備用電子信箱：作為重設密碼時可選擇的寄送信箱。\n\n二、會員之義務\n1.為了能使用本服務，您同意以下事項：\n註冊時提供您本人正確、最新及完整的資料，您所登錄之資料事後有變更時，應隨時於線上更新，確保其為正確、最新及完整之資料。若您未即時提供資料、未按指定方式提供資料、或所提供之資料不正確、不完整或與事實不符，本網站保留不經事先通知，隨時暫停或終止您的帳號，並拒絕您使用本服務之全部或一部之權利。\n如有任何虛假或冒用他人名義登錄，應自負法律責任。每位會員僅能註冊登錄一個帳號，不可重覆註冊登錄。\n2.會員可自行設定會員帳號和密碼，當您註冊完成後，有義務妥善保管您的帳號及密碼之機密與安全，不得洩漏予任何第三人。對於使用特定會員帳號和密碼、以及登入系統後之所有行為，均由持有該會員帳號和密碼之會員負責。\n3.該組帳號及密碼僅限於您個人使用，您不得出租、出借、移轉或讓與給其他第三人使用。若有前開情事者，本網站有權撤銷或終止該會員的使用權，並可限制該會員永久不得再使用本網站的服務，若因次發生損害，本網站有權追究該會員之法律責任。\n4.如發現您的帳號或密碼遭盜用或被他人不當使用，您必須立即利用本網站客服系統通知本網站，以利本網站採取適當因應措施；但上述因應措施不得解釋為本公司因此而明示或默示對會員負有任何形式之賠償或補償義務。\n5.當您完成使用本服務後，應確實登出並結束您帳號及密碼的使用，以防止被他人盜用。\n6.除遵守本服務條款之約定外，會員您瞭解本網站為一提供公眾服務之開放場所，您同意對您公佈於本網站或透過本網站傳輸的一切內容應自負全責，並承諾遵守中華民國相關法規及一切國際網際網路規定與慣例之相關規定，並同意不從事以下行為：\n竊取、更改、破壞他人資訊，或任何透過不正當管道竊取會員服務之會員帳號、密碼或存取權限之行為。\n破壞及干擾本服務所提供之各項資料、活動或功能；或以任何方式試圖侵入、破壞本服務之任何系統，或對會員資料有任何侵害或破壞行為。\n其他不符合會員服務所提供的使用目的之行為。\n\n三、會員之其他同意事項\n1.風險承擔：會員同意使用本網站各項服務係基於會員的個人意願，並同意自負任何風險，包括自本網站服務中獲得之資料導致會員的電腦系統損壞，或是發生任何資料流失等結果。\n2.特別同意事項：會員同意絕不使用本網站各項服務傷害、侵犯或攻擊本網站之雇主、員工、顧問、關係企業、廣告主以及相關合作廠商。\n3.損害賠償：因會員違反相關法令或違背本同意書之任一會員條款，致本網站或其關係企業、受僱人、受託人、代理人及其他相關履行輔助人因此而受有損害或支出費用（包括且不限於因進行民事、刑事及行政程序所支出之律師費用）時，會員應負損害賠償責任及填補其費用。\n\n四、會員服務\n1.您於本網站完成註冊程序後即取得會員資格，可開始使用本服務。\n2.本公司將依本系統當時所建置的服務項目、內容、狀態及功能，對會員提供服務；本公司保留隨時新增、減少或變更各該服務項目、內容及功能之全部或一部之權利，且無需事先或個別通知會員，有關現有或將來之各項服務均受本服務條款之規範。無論任何情形，就停止或更改服務之決定，本網站對任何會員或第三人均不負任何責任。\n3.您如加入本網站下之其他活動網站，而另有訂定相關使用規範或約定時，您應同時遵守各該服務之使用及相關規定。\n4.本公司會主動、或依會員之訂閱，寄送定時或不定時的各式電子報至會員所登錄的電子信箱帳號。當會員收到訊息後表示拒絕接受行銷時，應自行登入會員系統，取消「電子報訂閱」勾選選項，於勾選選項變更完成之兩週後，本網站將停止繼續發送電子報予該會員。\n5.本公司將不定期提供會員專屬之獨享活動，如消費抽獎、行銷訊息、行銷贈品等，惟會員須完成認證方可參與會員之獨享活動。\n\n五、會員隱私權保護\n1.對於會員所登錄或留存之個人資料，本網站同意在未依法律規定或是獲得會員同意時，不對外揭露會員之姓名、地址、電子郵件、地址及其他依法受保護之個人資料，但是在下列的情況下，本公司有可能會查看或提供會員的個人資料或相關電信資料給相關政府機關、或主張其權利受侵害並提出適當證明之第三人：\n依法令規定、或依司法機關或其他相關政府機關的命令、或其他有權機關基於法定程序之要求。\n會員涉及違反法令、侵害第三人權益、或違反本使用條款或各該使用規範或約定。\n為保護會員服務系統之安全或經營者之合法權益。\n為保護其他使用者或其他第三人的合法權益。\n為維護本系統的正常運作。\n2.對於會員所登錄或留存之個人資料，會員同意本網站及關係企業或合作對象，得於合理之範圍內蒐集、處理、保存、傳遞及利用該等資料，以提供使用者行銷、其他資訊或服務、或作成會員統計資料、或進行關於網路行為之調查或研究，或為任何之合法使用，或提供其他服務。\n3.因使用本服務所提供之網路活動，可能須透過宅配或貨運業者始能完成貨品（或贈品等）之配送或取回，因此，會員同意並授權本網站得視該次網路活動之需求及目的，將由會員所提供且為配送所必要之個人資料（如收件人姓名、配送地址、連絡電話等），提供予宅配、貨運等運送業者及相關配合之廠商，以利完成該次貨品（或贈品等）之配送、取回。\n4.倘會員拒絕前述蒐集、處理、保存、傳遞及利用者，請以 Email 至服務信箱（service@hecafe.com.tw）告知本網站，經本網站進行身份確認後，本網站將依會員拒絕之請求進行相關處理。\n5.會員若表示無法透過網路請求本網站進行會員資料查詢、修改、刪除或相關變動之服務時，需提供詳細個人資料【即身份證字號（必要時需出示身分證影本圖片）、姓名、出生年月日、個人電話、手機、住址】以供查核會員身分，若會員拒絕提供前述任一項個人資料，本網站服務人員有權拒絕會員進行後續會員資料調整之請求。另為善盡本網站管理人之責及保障會員權益，本公司將保留會員請求上述服務時之相關紀錄及其內提供之所有個人資訊，當會員提供個人資料時，視同接受本公司留存其記錄之作業。\n6.本網站就會員的行為是否符合會員規範，有最終決定權。若本網站決定會員的行為違反本會員規範或任何法令，會員同意本網站得隨時停止帳號使用權或清除帳號，及停止使用本網站服務。會員在違反法律規定之情事，應自負法律責任。\n\n六、擔保責任免除\n1.本網站就各項服務或內容，不負任何明示或默示之擔保責任。不保證各項服務或內容之穩定、安全、無誤、及不中斷。會員明示承擔使用本服務之所有風險及可能致生之任何損害。倘有遇到任何風險及可能致生之任何損害之虞時，建議會員應立即停止使用本網站。\n2.本網站不保證使用者與本網站間資料傳輸速率，倘客戶因傳輸速率或擷取使用網路資料而導致直接或間接之損害或損失時，本網站不負任何損害賠償責任。\n3.本網站上所有廣告，均由各該產品與服務的供應商所設計與提出製作素材，會員對於廣告內容之正確性與可信度應自行判斷，本網站僅提供網站供刊登，對該廣告相關內容不負擔保責任。\n\n七、賠償責任限制\n1.如本網站將會員傳送之任何訊息及內容刪除或未儲存，本網站不負擔任何損害賠償責任，您應自行定期備份資料。\n2.本網站對於會員使用各項服務、或無法使用各項服務所致生之任何直接、間接、衍生、或特別損害，不負任何賠償責任。若會員使用之服務係有對價者，本網站僅於會員所負之對價範圍內，負賠償責任。\n3.上述賠償責任限制將在法令所允許之最大範圍內適用之，但其未排除法令賦予會員之強制性保護。\n\n八、服務暫停或中斷\n1.本網站將以合理之方式及技術，維護會員服務之正常運作，但如有下列情形之一時，本網站得暫停或中斷本服務之全部或一部，對於使用者不負擔任何賠償責任：\n對於相關系統設備進行遷移、更換或維護時。\n因於天災等不可抗力之因素或不可歸責於本網站所造成服務停止或中斷時。\n對電子通信設備進行必要之保養及施工時。\n發生突發性之電子通信設備故障時。\n非本網站所得控制之事由而致您的服務資訊顯示不正確、或遭偽造、竄改、刪除或擷取時。\n由於本網站所申請之電子服務不論任何原因被停止，無法提供服務時。\n會員應瞭解並同意，本網站可能因公司、其他協力廠商或相關電信業者網路系統軟硬體設備之故障或失靈、或人為操作上之疏失而全部或一部中斷、暫時無法使用、遲延、或造成資料傳輸或儲存上之錯誤、或遭第三人侵入系統篡改或偽造變造資料等，會員不得因此而要求任何補償或賠償。\n您有任何違反政府法令或本服務條款時。\n2.如因本網站對於相關系統設備進行遷移、更換或維護而必須暫停或中斷全部或一部之服務時，本網站於暫停或中斷前將於本網站上公告。\n3.本網站得隨時因法令或其他情事而增訂、修改、暫停或終止本服務條款及相關規定，經公開之公告，於本網站公告即生效，本網站將不對會員個別通知，您不得據此對本網站主張任何權利。\n4.有關條款之增訂、修改，如您於公告後繼續使用本服務，則視為您已經同意該修訂條款。\n5.對於本服務之暫停或中斷，可能造成您使用上的不便、資料遺失或其他經濟及時間上之損失，您平時應採取適當的防護措施，以保障您的權益。\n\n九、智慧財產權\n1.本網站所使用之軟體、程式及網站上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、網站畫面的安排、網頁設計，均由本網站或其他權利人依法擁有使用權、所有權及智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。\n2.任何人不得逕自使用、修改、重製、公開播送、改作、散佈、發行、公開發表或進行還原工程（reverse engineering）、解編（de-compile）或反向組譯（disassemble），以其他任何形式、基於任何目的加以使用。若您欲引用或轉載前述軟體、程式或網站內容，必須依法取得本網站或其他權利人的事前書面同意。如有違反，您應對本網站或其他權利人負所有法律責任，本網站或其他權利人得依法請求賠償（包括但不限於訴訟費用及律師費用等）。\n3.本網站只提供會員以登入的方式使用需會員資格的服務，若以其他任何方式進入本網站系統，本網站將追究該人員相關之法律責任。\n\n一〇、個別條款之效力\n1.如本網站未行使本條款所載之任何法定權利或救濟時，不得視為本網站對權利之放棄，您同意本網站仍享有該等權利或救濟。\n2.如本服務條款任一規定經對本案具管轄權之法院裁定無效，則該等規定將自本條款中刪除，而不影響本服務條款其他部分，本服務條款其餘部分將持續有效並得以執行。\n\n一一、準據法及管轄權\n1.本使用條款及各該會員服務之相關使用規範及約定，均以中華民國法令為準據法。2.因會員服務、或本使用條款及各該會員服務之相關使用規範及約定所發生之爭議，如因此而訴訟，以台灣台北地方法院為第一審管轄法院。
            `}
          </Content>
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  & > .banner {
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    width: 100%;
    height: 600px;
    background-color: lightgray;

    & > h3 {
      position: absolute;
      z-index: 3;
      text-align: center;
      letter-spacing: 20px;
      font-size: 54px;
      color: white;
    }

    @media screen and (max-width: 650px) {
      & > h3 {
        letter-spacing: 10px;
        font-size: 40px;
      }
    }

    @media screen and (max-width: 550px) {
      height: 300px;
      & > h3 {
        letter-spacing: 5px;
        font-size: 26px;
      }
    }
  }

  & > .container {
    margin: 0 auto;
    padding: 10px;
    max-width: 720px;
    width: 100%;
  }
`;

const Content = styled.div`
  padding: 70px 10px;
  white-space: pre-wrap;
  line-height: 40px;
  font-size: 14px;
  color: #353535;
`;

export default withPage(ServiceTermsPage);
